import { Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell";
import { ActivityPage } from "./pages/Activity";
import { AgentsPage } from "./pages/Agents";
import { CostsPage } from "./pages/Costs";
import { LibraryPage } from "./pages/Library";
import { LoginPage } from "./pages/Login";
import { MissionDetailPage } from "./pages/MissionDetail";
import { MissionsPage } from "./pages/Missions";
import { OverviewPage } from "./pages/Overview";
import { ProjectDetailPage, ProjectsPage } from "./pages/Projects";
import { SettingsPage } from "./pages/Settings";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Shell />}>
        <Route index element={<OverviewPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="missions" element={<MissionsPage />} />
        <Route path="missions/:id" element={<MissionDetailPage />} />
        <Route path="agents" element={<AgentsPage />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="costs" element={<CostsPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<div className="p-8 text-mu">Página no encontrada.</div>} />
      </Route>
    </Routes>
  );
}
